import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { Category as Icon } from '../../ui-components/Icons';

const comp = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <Icon className={props.classes.subHeaderIcon} />
        <Typography className={props.classes.title} variant='h6'>Categorie</Typography>
    </div>)
}

export const Categories = withStyles(styles)(comp)